module.exports = __webpack_public_path__ + "static/media/kcdc_sponsors.512c77dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kcdc_sponsors.jpg
// module id = 246
// module chunks = 0